import { Component } from '@angular/core';
import { IMenu } from '@noovle/ui-nav-bar';
// AngularFire
import { AngularFireAuth } from '@angular/fire/compat/auth';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']

})
export class AppComponent {
  menu:IMenu = [
    {
      label:"Page Visualizer",
      url:"/pages",
    },
  ] 
  constructor(public fireAuth: AngularFireAuth) { }
}

